export const productionSentryConfig = {
  enabled: true,
  debug: false,
  environment: 'production',
};
